import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { conflictDataActions, thumbnailStoreActions } from "../../store/store";
import CheckIcon from '@mui/icons-material/Check';
import "../annotator.css";
import { setHoveredThumbnail, setIsHovered, setOpen } from "../../store/ShelfView/popover";
// import MouseOverThumbnail from "../ShelfViewer/ShelfViewerThumbnailImage/MouseOverThumbnail";
import PopUp from "./PopUp";
import { resetState, setAnchor, setClickedThumbnail, setOpenClicked } from "../../store/ShelfView/conflictsPage";
import axios from "axios";
// const get_image_url = (image) => {
//     return (
//       `https://caiproduction002.blob.core.windows.net/ira/audit_images/` +
//       image +
//       `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`
//     );
// };
const get_image_url = async (image) => {
	try {
		const urlData = await axios.post("/get_context/getImageURL", {
			"imageName": image,
			"folderName":"audit_images"
		})
		const imageUrl = urlData.data;
		console.log(imageUrl,"LINE 51")
		return imageUrl
	} catch (error) {
		console.error("Error fetching image:", error.message);
		return null;
	}
};

const GenerateConflictedThumbnails = (data) => {
    // console.log("thumbnail props", data.data)
    let props={...data.data}
    const dispatch = useDispatch();
    const {open,isHovered}=useSelector((state)=>state.popoverStore);
    const imageUrl = get_image_url(props.imageName);
    const xmin = props.xmin;
    const ymin = props.ymin;
    const xmax = props.xmax;
    const ymax = props.ymax;
    const canvasRef = useRef(null);
    const [cropDim, setCropDim] = useState([]);
    const {zoomDynamicHeight } = useSelector(state => state.shelfViewFeedbackStore)
   

    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, xmax - xmin, ymax - ymin);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = imageUrl;
      img.onload = async () => {
        const cropX = xmin; // X-coordinate of the top-left corner of the crop area
        const cropY = ymin; // Y-coordinate of the top-left corner of the crop area
        const cropWidth = xmax - xmin; // Width of the crop area
        const cropHeight = ymax - ymin; // Height of the crop area
  
        setCropDim([cropWidth, cropHeight]);
  
        canvas.width = cropWidth;
        canvas.height = cropHeight;
        ctx.drawImage(
          img,
          cropX,
          cropY,
          cropWidth,
          cropHeight,
          0,
          0,
          cropWidth,
          cropHeight
        );
      };
    }, [imageUrl, xmin, xmax, ymin, ymax]);
  
    const width = cropDim[0];
    const height = cropDim[1];
  
    const ratio = width / height;
    const dynamicHeight = zoomDynamicHeight;
    const dynamicWidth = dynamicHeight * ratio;

  
    return (
      <div className="thumbnail">
        <canvas
          ref={canvasRef}
          style={{ width: dynamicWidth + `px`, height: dynamicHeight + `px` }}
         
        />
        {props.discarded && <CheckIcon 
          className="correct-icon" 
          sx={{
            fontSize: "1rem"
          }}
        />}
      
      </div>
    );
  };

  export default GenerateConflictedThumbnails;